export default class QueryParams {
    constructor() {
    }

    /**
     * Get Query parameters and values from url
     * @returns {} Query parameters as object
     */
    getQueryParamsAsObject() {
        const queryElements = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&');
        return queryElements.reduce((params, queryElements) => {
            const splitQueryElements = queryElements.indexOf('=');

            if (splitQueryElements < 0) {
                return Object.assign(params, {});
            }

            const objectKey = queryElements.slice(0, splitQueryElements);
            const objectValue = queryElements.slice(splitQueryElements + 1);

            return Object.assign(params, {
                [objectKey]: decodeURIComponent(objectValue),
            });
        }, {});
    }
}
